/**
 * @file Performance.js
 * @description Cross-browser performance tracking
 * @author Stanley Clark <stanley@studyportals.com>
 * @copyright © 2018 Studyportals B.V., all rights reserved.
 * @version 1.0.0
 */

const Performance = {
	/**
	 * Create a performance mark with a certain name
	 * @param {string} name - the name of the mark
	 */
	createMark(name) {
		if (!window || !window.performance || !window.performance.mark) {
			console.warn('Performance.createMark: Performance functionality not available.');
			return;
		}

		performance.mark(`${name}_mark`);
	},

	/**
	 * Record the difference between two marks and send to redshift
	 * @param {object} options			- options object
	 * @param {string} options.category - the se_category to use
	 * @param {string} options.action 	- the se_action to use
	 * @param {string} options.start 	- the start mark
	 * @param {string} options.end 		- the end mark
	 */

	send(options) {
		if (!window || !window.performance || !window.performance.measure || !window.performance.getEntriesByName) {
			console.warn('Performance.send: Performance functionality not available.');
			return;
		}

		try {
			performance.measure(`${options.action}_measure`, `${options.start}_mark`, `${options.end}_mark`);
		} catch (e) {
			console.error(e.message);
			return;
		}

		const measures = performance.getEntriesByName(`${options.action}_measure`);
		const measure = measures[0];
		const duration = Math.round(measure.duration);

		this.trackTimingEvent({
			category: options.category,
			action: options.action,
			label: duration
		});
	},

	/**
	 * Send a performance timing event to redshift
	 * @param {object} options				- options object
	 * @param {string} options.category 	- the se_category
	 * @param {string} options.action 		- the se_action
	 * @param {string|number} options.label - the duration measured
	 */
	trackTimingEvent(options) {
		Shared.addFunctionToPipelineTracker((dataTracker) => {
			dataTracker.trackStructEvent(options.category, options.action, options.label);
		});
	}
};

window.Performance = Performance;
export default Performance;
